import { render, staticRenderFns } from "./PendingValidations.vue?vue&type=template&id=bc30a694&"
import script from "./PendingValidations.vue?vue&type=script&lang=js&"
export * from "./PendingValidations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QBreadcrumbs,QBreadcrumbsEl,QCard,QCardSection,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBreadcrumbs,QBreadcrumbsEl,QCard,QCardSection,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QBtn})
